import React from 'react';
import LaneContainer from '../UI/LaneContainer';
import LoadingSpinner from '../UI/LoadingSpinner';
import YourBooksSectionHeader from '../YourBooks/YourBooksSectionHeader';
import { connectToReviews } from './containers/ReviewsDataStore';
import ReviewsCollapse from './ReviewsCollapse';
import ReviewsMenu from './ReviewsMenu';

export class Reviews extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showInGrid: false,
		};
	}

	componentDidMount() {
		this.initializeSource();
	}

	initializeSource = () => {
		if (this.props.match) {
			this.setState({ showInGrid: true });
		}
	};

	render() {
		const { showInGrid } = this.state;
		const { isLoading } = this.props.reviewsDataStore.state;
		return (
			<div
				style={{
					marginTop: showInGrid ? 64 : 0,
				}}>
				<LaneContainer
					majorHeader={
						<YourBooksSectionHeader
							headerText="Your Reviews"
							showInGrid={showInGrid}
						/>
					}>
					<React.Fragment>
						{!isLoading ? (
							<React.Fragment>
								{showInGrid ? (
									<ReviewsMenu />
								) : (
									<ReviewsCollapse />
								)}
							</React.Fragment>
						) : (
							<LoadingSpinner />
						)}
					</React.Fragment>
				</LaneContainer>
			</div>
		);
	}
}

export default connectToReviews(Reviews);
